// Modal de DETALLE de un abogado externo postulado a una búsqueda de Revisión Documental

import React from 'react';
import { StarActiveIcon } from 'assets/icons';
import { User } from 'components';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RevisionService } from 'services';
import { Globals } from 'utils';

// lawyer: objeto armado por revision.tsx al abrir este modal, con los datos ya
// conocidos de la postulación (id, price/fee, lawyer_reference_price, should_pay,
// area/document) -- mismo contrato que RevisionLawyerActionData en el móvil.
interface Props extends RootState {
  lawyer: any;
  action?: any;
}

class ModalLawyerRevision extends React.Component<Props> {
  state = {
    data: null as any,
  };

  componentDidMount() {
    this.load();
  }

  // Trae biografía/experiencia/rating/datos bancarios del abogado seleccionado --
  // mismo endpoint que usa lawyer-info.tsx en el móvil (RevisionService.getLawyerDetail).
  load = async () => {
    const res: any = await RevisionService.getLawyerDetail({
      lawyer_id: this.props.lawyer?.id,
      withoutLoading: true,
    });
    this.setState({ data: res.lawyer || null });
  };

  render() {
    const { lawyer } = this.props;
    const data: any = this.state.data;

    return (
      <div id='modal-lawyer'>
        <div className='body'>
          <div className='lawyer'>
            <User image={data?.photo} name={data?.full_name} title='Abogado' />
            <div className='rating'>
              <p>
                {data?.avgRating
                  ? Globals.formatMiles(data?.avgRating, true, '')
                  : 'Sin calificación'}
              </p>
              <img src={StarActiveIcon} />
            </div>
          </div>

          <div className='description'>
            <p className='area'>{lawyer?.area?.name}</p>
            <p className='document'>{lawyer?.document?.name}</p>

            {/* Fee de plataforma DESACTIVADO temporalmente en revisión documental
                con abogados externos: el servicio ahora es accesible sin cobro
                de fee para cualquier usuario (should_pay siempre es false, ver
                revision.tsx#openLawyerDetail), así que este bloque ya no se
                muestra.
            {lawyer?.should_pay ? (
              <div className='container-total'>
                <div style={{ flex: 1 }}>
                  <p className='note'>Monto de pago a plataforma</p>
                </div>
                <p className='price'>{lawyer?.price}$</p>
              </div>
            ) : lawyer?.platform_fee_exempt ? (
              <p className='note'>Este abogado no cobra comisión de plataforma.</p>
            ) : (
              <p className='note'>
                Su membresía incluye este servicio. No debe pagar fee de plataforma.
              </p>
            )}
            */}

            {/* Precio referencial: solo informativo -- el precio real del trabajo se
                acuerda directamente entre cliente y abogado, fuera de la plataforma. */}
            {lawyer?.lawyer_reference_price != null && (
              <div className='container-total'>
                <div style={{ flex: 1 }}>
                  <p className='note'>Honorarios al abogado (a acordar)</p>
                </div>
                <p className='price'>{lawyer?.lawyer_reference_price}$</p>
              </div>
            )}

            {(data?.bank_data?.payment_mobile_bank || data?.bank_data?.transfer_bank) && (
              <p className='note' style={{ marginTop: '10px' }}>
                Datos bancarios del abogado:
              </p>
            )}

            {data?.bank_data?.payment_mobile_bank && (
              <div>
                <div className='text-right'>
                  <h6>Pago Móvil</h6>
                </div>
                <p className='data-pay'>Banco: {data?.bank_data?.payment_mobile_bank?.name}</p>
                <p className='data-pay'>
                  Teléfono: {data?.bank_data?.payment_mobile_phonecode?.name}
                  {data?.bank_data?.payment_mobile_phone}
                </p>
                <p className='data-pay'>
                  Cédula o RIF: {data?.bank_data?.payment_mobile_document_type?.name}
                  {data?.bank_data?.payment_mobile_document}
                </p>
              </div>
            )}

            {data?.bank_data?.transfer_bank && (
              <div>
                <div className='text-right'>
                  <h6>Transferencia</h6>
                </div>
                <p className='data-pay'>Banco: {data?.bank_data?.transfer_bank?.name}</p>
                <p className='data-pay'>Número de cuenta: {data?.bank_data?.transfer_account}</p>
                <p className='data-pay'>Tipo de cuenta: {data?.bank_data?.transfer_type_text}</p>
                <p className='data-pay'>
                  Cédula o RIF: {data?.bank_data?.transfer_document_type?.name}
                  {data?.bank_data?.transfer_document}
                </p>
              </div>
            )}

            <p className='text'>
              Nota: El precio del trabajo lo define el abogado y se acuerda directamente con él,
              fuera de la plataforma.
            </p>
          </div>
        </div>

        <div className='specialities'>
          <div className='header'>
            <p>Especialidad</p>
          </div>
          {data?.user_areas?.map((item: any, idx: number) => (
            <div className='item' key={idx}>
              <p>{item?.area?.name}</p>
            </div>
          ))}
        </div>

        {data?.biography && (
          <div className='info'>
            <p className='subtitle'>Biografía</p>
            <p className='biography'>{data?.biography}</p>
          </div>
        )}

        {data?.experience_text && (
          <div className='info'>
            <p className='subtitle'>Experiencia</p>
            <p>{data?.experience_text}</p>
          </div>
        )}

        {this.props.action && (
          <button className='btn' onClick={this.props.action}>
            {lawyer?.should_pay ? 'Pagar fee y adquirir' : 'Adquirir'}
          </button>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return { user: state.user };
})(ModalLawyerRevision);
